export namespace ServiceTicket {
  export enum ServiceTicketPage {
    Create = 'create',
    Call = 'call',
    Articles = 'articles',
  }

  export enum CreatePageSteps {
    Init = 'init',
    EnterSerial = 'enterSerial',
    EnterErrorCodeLoader = 'enterErrorCodeLoader',
    EnterErrorCode = 'enterErrorCode',
    EnterOtherErrorCode = 'enterOtherErrorCode',
    CallSupport = 'callSupport',
    DetailedInformation = 'detailedInformation',
    AdditionalArticlesLoader = 'additionalArticlesLoader',
    AdditionalArticles = 'additionalArticles',
  }

  export enum CallPageSteps {
    Feedback = 'feedback',
    RoutingProviderLoader = 'routingProviderLoader',
    CallType = 'callType',
    RequestLoader = 'requestLoader',
    ResultCallNow = 'resultCallNow',
    ResultArrangedCallback = 'resultArrangedCallback',
  }

  export enum SupportPageSteps {
    DetailedInformation = 'detailedInformation',
    AdditionalArticles = 'additionalArticles',
  }
}

export interface ServiceTicketErrorDetails {
  detailsInDifferentLanguage: boolean;
  details: ServiceTicketError[];
}

export interface ServiceTicketError {
  faultCode: string;
  systemCharacteristics: string;
  causes: {
    cause: string;
    measure: string;
  }[];
  text: string;
}

export enum ServiceTicketCallType {
  CallNow = 'callNow',
  ArrangedCallback = 'arrangedCallback',
}

export enum ServiceTicketRoutingProvider {
  Salesforce = 'Salesforce',
  Vonage = 'Vonage',
}

export interface ServiceTicketCallNowDetails {
  callNumber: string;
}

export interface ServiceTicketArrangedCallback {
  id: string;
  device: string;
  time: string;
  dismissTime: string;
  timestamp: number;
}

export const ARRANGED_CALLBACKS_LOCALSTORAGE_TOKEN = 'arrangedCallbacks';

export interface ServiceTicketCallback {
  id: string;
  device: string;
  time: string;
  dismissTime: string;
  timestamp: number;
}
import { FaultCode, InstallationItemGatewayDeviceFull } from '@vi-iot/client';

export interface SearchDeviceItemViewValue {
  value: InstallationItemGatewayDeviceFull;
  viewValue: string;
  inputViewValue?: string;
  column?: string[];
}

export interface ErrorCodeItemViewValue {
  value: FaultCode;
  viewValue: string;
  inputViewValue: string;
}

export interface ServiceTicketErrorCodes {
  errorCode: string[];
  otherErrorCode: string;
  otherErrorSelected: boolean;
}

export enum ServiceTicketBoilerSerialErrors {
  NonNumericValue = 'NonNumericValue',
  GatewaySerialInsteadOfBoilerSerial = 'GatewaySerialInsteadOfBoilerSerial',
}
